import { Component, AfterViewInit, Renderer2, OnDestroy } from '@angular/core';
import { MenuService } from '../../service/app.menu.service';
import { MenuItem, PrimeNGConfig } from 'primeng/api';
import { AppComponent } from '../../../../app.component';
import { StorageService } from 'src/app/modules/common/service/storage/storage.service';
import { FilterService } from 'src/app/modules/common/service/filter/filter.service';
import { NavigationEnd, Router } from '@angular/router';
import { select, Store } from '@ngrx/store';
import { loadList } from '../../lib/action';
import { AdministrationService, INavigationData, NavigationService } from '../../service';
import { distinctUntilChanged, filter, map, Observable } from 'rxjs';
import { CommonService } from '../../service/common/common.service';
import { SubSink } from 'subsink';
import { MsalService } from '@azure/msal-angular';
import { environment } from 'src/environments/environment';
import { AccountInfo } from '@azure/msal-browser';

@Component({
    selector: 'app-main',
    templateUrl: './app.main.component.html',
    styleUrls: ['./app.main.component.scss']
})
export class AppMainComponent implements AfterViewInit, OnDestroy {
    // userDetails = JSON.parse(localStorage.getItem("userDetails"))

    rotateMenuButton: boolean;

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean = false;

    staticMenuMobileActive: boolean;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    documentClickListener: () => void;

    configActive: boolean;

    configClick: boolean;

    rightPanelActive: boolean;

    rightPanelClick: boolean;

    menuHoverActive = false;

    searchClick = false;
    userDetails$: Observable<any>;
    privilegeList$: Observable<any>;
    search = false;
    isSuperuser: boolean = false;
    selectedClientId: any;
    items: any;
    home: MenuItem | undefined;
    isManual: any;
    private subscription = new SubSink();
    currentNav: INavigationData = null;
    public viewInfo: string = "Dashboard";
    isProfileLoaded = false
    isUserListLoaded = false
    isAccessLoaded = false

    constructor(
        public renderer: Renderer2,
        private adminService: AdministrationService,
        private menuService: MenuService,
        private primengConfig: PrimeNGConfig,
        public app: AppComponent,
        public storageService: StorageService,
        public filterService: FilterService,
        public router: Router,
        private store: Store<any>,
        private refreshService: CommonService,
        private navigationService: NavigationService,
        private msalService: MsalService
    ) {

        this.menuClick = false;
        this.userDetails$ = this.store.pipe(select(state => state.data.data));
        this.privilegeList$ = this.store.pipe(select(state => state?.lists?.privileges));

    }

    ngOnInit() {
        this.isManual = localStorage.getItem('manual-logged-in') === 'true';
        let account: AccountInfo | null = this.msalService.instance.getActiveAccount();
        if (!account) {
            const accounts = this.msalService.instance.getAllAccounts();
            if (accounts.length > 0) {
                account = accounts[0];
                this.msalService.instance.setActiveAccount(account);
            }
        }
        if (!account) {
            console.warn('[SSO Login] No MSAL account found.');
        }
        if (!this.isManual) {
            this.msalService.instance.acquireTokenSilent({
                account,
                scopes: environment.client_sso.bridgenet.sso.scopes
            }).then(d => {
                const token = d.accessToken;
                if (localStorage.getItem('token')) {
                    localStorage.removeItem('token');
                }
                localStorage.setItem('token', token);
                this.getProfileDetails().then(result => {
                    this.store.dispatch(loadList({ listType: 'profile' }));
                    this.store.dispatch(loadList({ listType: 'privileges' }));
                    this.userDetails$.subscribe(data => {
                        this.isSuperuser = data?.is_superuser;
                    });
                    this.adminService.setSelectedClientId(JSON.parse(localStorage.getItem('selectedClientId')) ?? null)
                    this.privilegeList$?.pipe(
                        map(data => {
                            this.selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
                            const selectedClientId = this.selectedClientId
                            if (selectedClientId) {
                                return data?.[selectedClientId];
                            }
                            return null;
                        }),
                        distinctUntilChanged(),
                        filter(appPrivileges => !!appPrivileges)
                    ).subscribe((appPrivileges: any) => {
                        this.adminService.setPrivilegeList(appPrivileges);
                    });
                    this.adminService.privilegeList$?.pipe(
                        distinctUntilChanged(),
                        filter(privilegeList => !!privilegeList)
                    ).subscribe(privilegeList => {
                        this.selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
                        const selectedClientId = this.selectedClientId
                        if (selectedClientId) {
                            this.adminService.setPrivilegeList(privilegeList);
                        }
                    });

                }).catch(e => {
                    console.error(e)
                });
            })
        } else {
            this.getProfileDetails().then(result => {
                this.store.dispatch(loadList({ listType: 'profile' }));
                this.store.dispatch(loadList({ listType: 'privileges' }));
                this.userDetails$.subscribe(data => {
                    this.isSuperuser = data?.is_superuser;
                });
                this.adminService.setSelectedClientId(JSON.parse(localStorage.getItem('selectedClientId')) ?? null)
                this.privilegeList$?.pipe(
                    map(data => {
                        this.selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
                        const selectedClientId = this.selectedClientId
                        if (selectedClientId) {
                            return data?.[selectedClientId];
                        }
                        return null;
                    }),
                    distinctUntilChanged(),
                    filter(appPrivileges => !!appPrivileges)
                ).subscribe((appPrivileges: any) => {
                    this.adminService.setPrivilegeList(appPrivileges);
                });
                this.adminService.privilegeList$?.pipe(
                    distinctUntilChanged(),
                    filter(privilegeList => !!privilegeList)
                ).subscribe(privilegeList => {
                    this.selectedClientId = JSON.parse(localStorage.getItem('selectedClientId'));
                    const selectedClientId = this.selectedClientId
                    if (selectedClientId) {
                        this.adminService.setPrivilegeList(privilegeList);
                    }
                });
            }).catch(e => {
                console.error(e)
            });
        }

        this.getUserJSONDetails();
        this.router.events
            .pipe(filter(event => event instanceof NavigationEnd))
            .subscribe(() => {
                this.updateBreadcrumb();
            });

        // Also call it initially
        this.updateBreadcrumb();
        // setTimeout(() => {
        //     let url = this.router.url.split('/').splice(2);
        //     let accumulatedPath = '';
        //     this.items = url.map((item, index) => {
        //         let label = '';
        //         accumulatedPath += `/${item}`;
        //         // Check if current item is a number and the previous one is "rateCard"
        //         if (!isNaN(Number(item)) && url[index - 1] === 'rateCard') {
        //             label = 'Surcharge Management';
        //         } else {
        //             switch (item) {
        //                 case 'admin':
        //                     label = 'Administration';
        //                     break;
        //                 case 'customer-sbu-management':
        //                     label = 'Customer SBU Management';
        //                     break;
        //                 case 'rateCard':
        //                     label = 'Rate Card Management';
        //                     break;
        //                 case 'uom-management':
        //                     label = 'UOM Management';
        //                     break;
        //                 case 'docstatus-management':
        //                     label = 'Document Action';
        //                     break;
        //                 case 'service-type':
        //                     label = 'Charge Type';
        //                     break;
        //                 case 'shipment':
        //                     label = 'Shipment Management';
        //                     break;
        //                 default:
        //                     label = item
        //                         .split('-')
        //                         .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        //                         .join(' ');
        //                     break;
        //             }
        //         }
        //         if (item === 'rateCard' && this.router.url.startsWith('/user/master-data/rateCard/')) {
        //             return {
        //                 label,
        //                 routerLink: '/user/master-data/rateCard'
        //             };
        //         }
        //         return { label };
        //     });
        // },20);

        // this.home = { icon: 'pi pi-home', routerLink: '/user/search/document-grid' };

    }
    updateBreadcrumb() {
        let url = this.router.url.split('/').splice(2);
        let accumulatedPath = '';
        this.items = url.map((item, index) => {
            let label = '';
            accumulatedPath += `/${item}`;

            if (!isNaN(Number(item)) && url[index - 1] === 'rateCard') {
                label = 'Surcharge Management';
            } else {
                switch (item) {
                    case 'admin':
                        label = 'Administration';
                        break;
                    case 'customer-sbu-management':
                        label = 'Customer SBU Master Data';
                        break;
                    case 'customer-management':
                        label = 'Customer Master Data';
                        break;
                    case 'rateCard':
                        label = 'Rate Card Management';
                        break;
                    case 'uom-management':
                        label = 'UOM Management';
                        break;
                    case 'docstatus-management':
                        label = 'Document Action';
                        break;
                    case 'service-type':
                        label = 'Charge Type';
                        break;
                    case 'shipment':
                        label = 'Shipment Management';
                        break;
                    default:
                        label = item
                            .split('-')
                            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                            .join(' ');
                        break;
                }
            }

            if (item === 'rateCard' && this.router.url.startsWith('/user/master-data/rateCard/')) {
                return {
                    label,
                    routerLink: '/user/master-data/rateCard'
                };
            }

            return { label };
        });
        this.home = { icon: 'pi pi-home', routerLink: '/user/search/document-grid' };
    }
    getUserJSONDetails() {
        this.refreshService.getUserListJSONDetails().subscribe({
            next: (res) => {
                this.filterService.sendUserDetailsJSON(res?.results);
                localStorage.setItem('userNameDetails', JSON.stringify(res?.results))
                this.isUserListLoaded = true
            },
            error: () => {

            }
        })
    }

    goBackToRateCard(): void {
        this.router.navigate(['/user/master-data/rateCard']);
    }
    getProfileDetails(): Promise<any> {
        return new Promise((resolve, reject) => {
            const token = localStorage.getItem('token');
            if (!token) {
                console.warn('Authorization token missing. Skipping profile fetch.');
                return;
            }
            this.refreshService.getProfileDetails().subscribe({
                next: (res) => {
                    if (res) {
                        if (!res.is_superuser) {
                            localStorage.setItem('Client Name', res.client_name);
                            localStorage.setItem('selectedClientId', res.client_id);
                            localStorage.setItem('selectedUserType', res.user_type);
                            localStorage.setItem('showExitButton', 'false');
                            localStorage.setItem('LOGO', res.logo);
                            localStorage.setItem('Footer', res.footer);
                        }

                        this.onClickViewApplicationAccess(res.id);
                        this.isProfileLoaded = true,
                            resolve(true);
                    }
                },
                error: () => {
                    // this.messageService.add({
                    //   severity: 'error',
                    //   key: 'emptyToster',
                    //   detail: 'SSO login not allowed for External user.'
                    // });
                    reject(false)
                }
            })
        })


    }

    onClickViewApplicationAccess(id) {
        CommonService.showLoader();
        this.adminService.getApplicationRoleDataAccess(id).subscribe({
            next: (res: any) => {

                CommonService.hideLoader();
                localStorage.setItem('userDetails', JSON.stringify(res));
                localStorage.setItem('RolePrivilege', JSON.stringify(res?.permissions));
                this.isAccessLoaded = true
                // this.userDetails = res;
                // this.selectedUserRole = this.userDetails?.roles[0];
                // this.firstLetter = this.userDetails?.profile?.dp_name;
                // this.isUnreadAnnouncement = this.userDetails?.announcement_read_flag;
            },
            error: () => {

                CommonService.hideLoader()
            }
        })
    }

    get isLoadContent() {
        return this.isProfileLoaded && this.isUserListLoaded && this.isAccessLoaded
    }

    ngAfterViewInit() {
        // hides the horizontal submenus or top menu if outside is clicked
        this.documentClickListener = this.renderer.listen('body', 'click', (event) => {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            setTimeout(() => {
                let url = this.router.url.split('/').splice(2);
                let accumulatedPath = '';
                this.items = url.map((item, index) => {
                    let label = '';

                    accumulatedPath += `/${item}`;

                    // Check if current item is a number and the previous one is "rateCard"
                    if (!isNaN(Number(item)) && url[index - 1] === 'rateCard') {
                        label = 'Surcharge Management';
                    } else {
                        switch (item) {
                            case 'admin':
                                label = 'Administration';
                                break;
                            case 'customer-sbu-management':
                                label = 'Customer SBU Master Data';
                                break;
                            case 'customer-management':
                                label = 'Customer Master Data';
                                break;
                            case 'rateCard':
                                label = 'Rate Card Management';
                                break;
                            case 'docstatus-management':
                                label = 'Document Action';
                                break;
                            case 'uom-management':
                                label = 'UOM Management';
                                break;
                            case 'service-type':
                                label = 'Charge Type';
                                break;
                            case 'shipment':
                                label = 'Shipment Management';
                                break;
                            default:
                                label = item
                                    .split('-')
                                    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                                    .join(' ');
                                break;
                        }
                    }
                    if (item === 'rateCard' && this.router.url.startsWith('/user/master-data/rateCard/')) {
                        return {
                            label,
                            routerLink: '/user/master-data/rateCard'
                        };
                    }



                    return { label };
                });
            }, 20);

            this.home = { icon: 'pi pi-home', routerLink: '/user/search/document-grid' };

            if (!this.menuClick && this.isHorizontal()) {
                this.menuService.reset();
            }

            if (this.configActive && !this.configClick) {
                this.configActive = false;
            }

            if (!this.rightPanelClick) {
                this.rightPanelActive = false;
            }

            if (!this.menuClick) {
                if (this.overlayMenuActive) {
                    this.overlayMenuActive = false;
                }
                if (this.staticMenuMobileActive) {
                    this.staticMenuMobileActive = false;
                }

                this.menuHoverActive = false;
                this.unblockBodyScroll();
            }
            if (!this.searchClick) {
                this.search = false;
            }
            this.searchClick = false;
            this.configClick = false;
            this.topbarItemClick = false;
            this.menuClick = false;
            this.rightPanelClick = false;
        });
    }

    onMenuButtonClick(event) {
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;
        this.menuClick = true;

        if (this.app.menuMode === 'overlay' && !this.isMobile()) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }

        if (this.isDesktop()) {
            this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
        } else {
            this.staticMenuMobileActive = !this.staticMenuMobileActive;
            if (this.staticMenuMobileActive) {
                this.blockBodyScroll();
            } else {
                this.unblockBodyScroll();
            }
        }

        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }
        if (item.className === 'search-item topbar-item') {
            this.search = !this.search;
            this.searchClick = !this.searchClick;
        }
        event.preventDefault();
    }

    onTopbarSubItemClick(event, ope: string = '', data: any) {
        event.preventDefault();
        if (ope == 'DOC' && data) {
            const { id, client_id, document_id, user_id } = data
            let notificationBody = {
                "user_id": user_id,
                "client_id": client_id,
                "notification_ids": [
                    id
                ]
            }
            this.refreshService.postNotificationRead(notificationBody).subscribe({
                next: (res) => {
                    // this.refreshService.onClickSendRefreshEvent(this.currentNav.route)
                    // this.router.navigate([`user/search/document-viewer/${client_id}/${document_id}`])
                    window.location.href = `user/search/document-viewer/${client_id}/${document_id}`
                },
                error: (e) => {
                    window.location.href = `user/search/document-viewer/${client_id}/${document_id}`
                }
            })
        }
    }

    onRTLChange(event) {
        this.app.isRTL = event.checked;
    }

    onRippleChange(event) {
        this.app.ripple = event.checked;
        this.primengConfig.ripple = event.checked;
    }

    onConfigClick(event) {
        this.configClick = true;
    }

    onRightPanelButtonClick(event) {
        this.rightPanelClick = true;
        this.rightPanelActive = !this.rightPanelActive;
        event.preventDefault();
    }

    onRightPanelClick() {
        this.rightPanelClick = true;
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isOverlay() {
        return this.app.menuMode === 'overlay';
    }

    isStatic() {
        return this.app.menuMode === 'static';
    }

    isHorizontal() {
        return this.app.menuMode === 'horizontal';
    }

    blockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.add('blocked-scroll');
        } else {
            document.body.className += ' blocked-scroll';
        }
    }

    unblockBodyScroll(): void {
        if (document.body.classList) {
            document.body.classList.remove('blocked-scroll');
        } else {
            document.body.className = document.body.className.replace(new RegExp('(^|\\b)' +
                'blocked-scroll'.split(' ').join('|') + '(\\b|$)', 'gi'), ' ');
        }
    }

    ngOnDestroy() {
        if (this.documentClickListener) {
            this.documentClickListener();
        }
    }

}
